import clsx from 'clsx';
import React, { useMemo } from 'react';

import { useUser } from 'hooks';
import { AccountCircleIcon, MoreHorizIcon } from 'icons';
import { IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, styled } from 'netline-ui';
import { getDisplayName } from 'utils';

import styles, { mobileUserInfoClasses } from './MobileUserInfo.styles';

type MobileUserInfoProps = {
  className?: string;
  onProfileMenuOpenClick: () => void;
};

const MobileUserInfoRoot = styled(List, { name: mobileUserInfoClasses.$name })(styles);

const MobileUserInfo = ({ className, onProfileMenuOpenClick }: MobileUserInfoProps) => {
  const { user } = useUser();

  const displayName = useMemo(() => getDisplayName(user?.profile), [user]);

  return (
    <MobileUserInfoRoot className={clsx(mobileUserInfoClasses.root, className)}>
      <ListItem>
        <ListItemIcon>
          <AccountCircleIcon className={mobileUserInfoClasses.avatar} />
        </ListItemIcon>
        <ListItemText className={mobileUserInfoClasses.userInfo} primary={displayName} />
      </ListItem>
      <ListItemSecondaryAction>
        <IconButton edge="end" aria-label="comments" onClick={onProfileMenuOpenClick}>
          <MoreHorizIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </MobileUserInfoRoot>
  );
};

export default MobileUserInfo;
